import React, { useContext } from "react";
import AuthContext from "../../context/AuthContext";

import "./login.css";

const Login = () => {
  let { loginUser } = useContext(AuthContext);

  return (
    <div className="logincardBackground">
      <div className="loginContainer">
        <h2 className="body">MV-Hair</h2>

        <form autoComplete="off" onSubmit={loginUser}>
          <div className="mb-3">
            <br />
            <input
              type="text"
              name="username"
              placeholder="Usuario"
              className="form-control"
              minLength="2"
              maxLength="50"
              required
            />
          </div>
          <div className="mb-3">
            <br />
            <input
              type="password"
              name="password"
              placeholder="Contraseña"
              className="form-control"
              required
            />
          </div>

          <div className="d-grid gap-2">
            <button type="submit" className="btn btn-success mt-4">
              Iniciar Sesion
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
